<div class="login-container">
    <!-- Loading Overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="loading-text">Signing you in...</p>
    </div>

    <div class="login-card" [class.loading]="isLoading">
        <!-- Left Side - Branding -->
        <div class="login-branding">
            <div class="branding-content">
                <div class="logo-wrapper">
                    <img class="logo" src="assets/img/qm_logo.jpeg" alt="QM Logo">
                </div>
                <h2 class="branding-title">Fleet Management System</h2>
                <p class="branding-subtitle">Streamline your logistics operations</p>
            </div>
            <div class="branding-footer">
                <div class="version-info">
                    <span class="version-item">v1.0.1</span>
                    <span class="version-divider"></span>
                    <span class="version-item">Angular 19</span>
                    <span class="version-divider"></span>
                    <span class="version-item env-badge">UAT</span>
                </div>
            </div>
        </div>

        <!-- Right Side - Login Form -->
        <div class="login-form-section">
            <div class="form-wrapper">
                <div class="form-header">
                    <h1 class="form-title">Welcome Back</h1>
                    <p class="form-subtitle">Please enter your credentials to continue</p>
                </div>

                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
                    <!-- Username Field -->
                    <div class="form-group" [class.error]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
                        <label class="form-label" for="username">
                            <mat-icon class="label-icon">person</mat-icon>
                            <span>Username</span>
                        </label>
                        <div class="input-wrapper">
                            <input
                                id="username"
                                type="text"
                                class="form-input"
                                formControlName="username"
                                placeholder="Enter your username"
                                autocomplete="username">
                        </div>
                        <span class="error-message" *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
                            Username is required
                        </span>
                    </div>

                    <!-- Password Field -->
                    <div class="form-group" [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                        <label class="form-label" for="password">
                            <mat-icon class="label-icon">lock</mat-icon>
                            <span>Password</span>
                        </label>
                        <div class="input-wrapper">
                            <input
                                id="password"
                                [type]="showPassword ? 'text' : 'password'"
                                class="form-input"
                                formControlName="password"
                                placeholder="Enter your password"
                                autocomplete="current-password">
                            <button type="button" class="toggle-password" (click)="togglePassword()">
                                <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                        </div>
                        <span class="error-message" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                            Password is required
                        </span>
                    </div>

                    <!-- Remember Me & Forgot Password -->
                    <div class="form-options">
                        <label class="remember-me">
                            <input type="checkbox" [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}">
                            <span class="checkmark"></span>
                            <span class="remember-text">Remember me</span>
                        </label>
                        <a href="#" class="forgot-link">Forgot Password?</a>
                    </div>

                    <!-- Submit Button -->
                    <button type="submit" class="submit-btn" [disabled]="isLoading">
                        <span *ngIf="!isLoading">Sign In</span>
                        <span *ngIf="isLoading" class="btn-loading">
                            <mat-spinner diameter="20"></mat-spinner>
                            <span>Signing in...</span>
                        </span>
                    </button>
                </form>

                <!-- Mobile Version Info -->
                <div class="mobile-version-info">
                    <span>v1.0.1</span>
                    <span class="dot"></span>
                    <span>Angular 19</span>
                    <span class="dot"></span>
                    <span class="env-badge">UAT</span>
                </div>
            </div>
        </div>
    </div>
</div>
